import * as ChronoUnit from 'automation-ui-flow-core/fields/time/ChronoUnit';
export const MINUTES_CONVERSION = {
  minuteDay: 1440,
  minuteHour: 60
};
export const TIME_UNIT_TO_MINUTES = {
  [ChronoUnit.MINUTES]: 1,
  [ChronoUnit.HOURS]: 60,
  [ChronoUnit.DAYS]: 1440,
  [ChronoUnit.WEEKS]: 10080
};
export function deltaToDHM(delta, timeUnit) {
  const minutes = delta * TIME_UNIT_TO_MINUTES[timeUnit];
  const {
    minuteDay,
    minuteHour
  } = MINUTES_CONVERSION;
  const days = Math.floor(minutes / minuteDay);
  const hrs = Math.floor(minutes % minuteDay / minuteHour);
  const min = Math.floor(minutes % minuteHour);
  return [days, hrs, min];
}